import { render, staticRenderFns } from "./MenuItemLink.vue?vue&type=template&id=b698629a&"
import script from "./MenuItemLink.vue?vue&type=script&lang=js&"
export * from "./MenuItemLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports